import { ShoppingCart } from '../models/shopping-cart.model';
import { CachedAppState } from './cached-app-state';

export class AppState extends CachedAppState {
  cart: ShoppingCart = new ShoppingCart();
  // don't cache so that we show the dialog once per full page reload.
  suppressBundlePriceAlert: boolean = false;
}
